import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import BlogCard from "./BlogCard";

import { Swiper, SwiperSlide } from "swiper/react";
import { SwiperOptions, Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import PaginationAndNavigation from "components/sliders/PaginationAndNavigation";
import axios from "axios";
import useSWR from "swr";
import bg from "public/images/bg/read-our-blogs.webp";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: `url(${bg.src})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 50%",
      backgroundPosition: "top",
      position: "relative",
    },
    slider: {
      "& .slick-slide > div": {
        margin: theme.spacing(4, 3),
        [theme.breakpoints.down("md")]: {
          margin: theme.spacing(1, 2),
        },
      },
      "& .slick-list": {
        margin: theme.spacing(0, -3),
        [theme.breakpoints.down("md")]: {
          margin: theme.spacing(0, -2),
        },
      },
      "& .slick-arrow": {
        top: "unset",
        bottom: -25,
      },
      "& .slick-prev": {
        left: "unset",
        right: 150,
      },
      "& .slick-next": {
        right: 0,
      },
    },
    dots: {
      listStyle: "none",
      display: "flex!important",
      margin: 0,
      padding: 0,
      position: "absolute",
      right: 40,
      marginTop: theme.spacing(0.487),

      "& li": {
        "& div": {
          cursor: "pointer",
          transition: "all .5s",
          width: 20,
          height: 7,
          borderRadius: 50,
          border: `1px solid ${theme.palette.primary.main}`,
          marginLeft: 5,
        },
      },
      "& li.slick-active": {
        "& div": {
          width: 35,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    heading: {
      color: theme.palette.common.white,

      "& span": {
        fontWeight: 500,
      },
    },
  })
);

const fetcher = (url) => axios.get(url).then((res) => res.data);

const OurBlogs: React.FC = () => {
  const classes = useStyles();
  const { data, error } = useSWR(
    process.env.NEXT_PUBLIC_BLOG_END_POINT,
    fetcher
  );

  const swiperSliderOptions: SwiperOptions = {
    modules: [Navigation, Pagination],
    lazy: true,
    cssMode: true,
    navigation: {
      nextEl: ".blog-slide-button-next",
      prevEl: ".blog-slide-button-prev",
    },
    pagination: {
      el: ".blog-slide-pagination",
      clickable: true,
      type: "bullets",
    },
    breakpoints: {
      "600": {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16,
      },
      "960": {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 32,
      },
      "1170": {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 48,
      },
    },
  };

  if (error)
    return (
      <Container className="position-relative">
        <p>An error has occurred.</p>
      </Container>
    );
  if (!data)
    return (
      <Container className="position-relative">
        <p>Loading...</p>
      </Container>
    );

  return (
    <Box className={classes.root} paddingY={[3, 5, 6, 8]} component="section">
      <Container className="position-relative">
        <Typography
          variant="h1"
          component="h3"
          align="center"
          className={classes.heading}
        >
          Explore our <span>Blogs</span>
        </Typography>
        <Box marginTop={[2, 3, 4, 5]}>
          <Swiper {...swiperSliderOptions}>
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <BlogCard
                  mb={24}
                  imagePath={
                    item.feature_image.medium
                      ? item.feature_image.medium
                      : "https://loremflickr.com/640/360"
                  }
                  title={item.title}
                  category={item.category}
                  author={item.author}
                  createdOn={item.created_on}
                  link={item.link}
                  content={item.content}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <PaginationAndNavigation
            nextClassName="blog-slide-button-next"
            prevClassName="blog-slide-button-prev"
            paginationClassName="blog-slide-pagination"
            align="end"
            paginationHideOnMobile={true}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default OurBlogs;
